export const getInitials = (name = '') =>
  name
    .split(' ')
    .map(part => part.charAt(0).toUpperCase())
    .join('')

export const stripFileExtension = (filename = '') => filename.replace(/\.[^/.]+$/, '')

export const safeNumberFromString = (str = '') => {
  const num = Number.parseInt(str, 10)
  return Number.isNaN(num) ? str : num
}
